import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import type {
  INPUT_MAPPING_SOURCE,
  InputMappingBackendResponse,
} from '@/features/InputMapping/types';

export class InputMappingHttpService extends HttpService {
  loadSourceByTypeAndId(
    _source: INPUT_MAPPING_SOURCE,
    id: string,
  ): HttpClientResponse<InputMappingBackendResponse> {
    return this.httpClient.get(`contracts/${id}`);
  }
}
